import React, { useState, useEffect } from "react";
import { Card, Table } from "react-bootstrap";

//components
import { clientlist } from "../../utils/const";
import OrderData from "./OrderData";
import { searchInputStyle } from "../../utils/commonStyles";
import PageTitle from "../../layouts/Pagetitle";
import PaginationComp from "../PaginationComp/PaginationComp";

import AddOrder from "./AddOrder";
import { modalOpener } from "../../utils/commonFn";

import ModalComp from "../../ModalComp/ModalComp";
import axiosInstance from "../../../services/AxiosInstance";

const Orders = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [displayData, setDisplayData] = useState("");
  const [foundResult, setFoundResult] = useState(clientlist);
  const [name, setName] = useState("");
  const [openAddOrderModal, setOpenAddOrderModal] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const disaplayDataHandler = (data) => {
    setDisplayData(data);
  };
  const filter = (e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      const results = clientlist.filter((user) => {
        return (
          user?.id.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user?.email.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user?.name.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user?.phone_no.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user?.price.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user?.status.toLowerCase().startsWith(keyword.toLowerCase())
        );
      });
      setFoundResult(results);
    } else {
      setFoundResult(clientlist);
    }
    setName(keyword);
  };

  useEffect(() => {
    axiosInstance.get("don/allorders").then((res) => {
      console.log("ORders data", res.data.data);
      setOrderData(res.data.data);
    });
  }, []);
  return (
    <div>
      {/* <PageTitle activeMenu="Orders" motherMenu="Clients" /> */}
      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-12 col-lg-12">
            <Card>
              <Card.Header>
                <Card.Title>Orders List</Card.Title>
                <button
                  onClick={() => modalOpener(setOpenAddOrderModal)}
                  className="btn btn-info shadow"
                >
                  Add Order
                </button>
              </Card.Header>
              <Card.Body>
                <div className="table-responsive">
                  <div class="form-group">
                    <input
                      type="search"
                      onChange={filter}
                      value={name}
                      style={searchInputStyle}
                      id=""
                      aria-describedby="helpId"
                      placeholder="Search anything...."
                    />
                  </div>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th scope="col" className="text-white">
                          Date
                        </th>
                        <th scope="col" className="text-white">
                          Order Id
                        </th>
                        <th className="text-white">Order Amount</th>

                        {/*        <th className="text-white">Email</th> */}
                        <th scope="col" className="text-white">
                          Status
                        </th>
                        <th scope="col" className="text-white">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayData && foundResult.length > 0 ? (
                        <OrderData data={displayData} />
                      ) : (
                        <h6>No results found!</h6>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
              <Card.Footer>
                {foundResult ? (
                  <PaginationComp
                    data={orderData ?? []}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    disaplayDataHandler={disaplayDataHandler}
                    searchedText={name}
                  />
                ) : (
                  <PaginationComp
                    data={orderData ?? []}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    disaplayDataHandler={disaplayDataHandler}
                    searchedText={name}
                  />
                )}
              </Card.Footer>
            </Card>
          </div>
        </div>
      </div>
      <ModalComp
        isOpen={openAddOrderModal}
        setisOpen={setOpenAddOrderModal}
        title="Add Member"
        hideButtons
      >
        <AddOrder closeModal={setOpenAddOrderModal} />
      </ModalComp>
    </div>
  );
};
export default Orders;
